
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { isDateWithinMaxRange } from '@/utils/timeFunctions';
import OrderItemsList from '@/components/suites/beo/OrderItemsList.vue';
import OrderItem from '@/components/suites/beo/OrderItem.vue';
import OrdersTable from '@/components/report/OrdersTable.vue';
import ChitPrint from '@/components/report/ChitPrint.vue';
import OrdersReportExportModal from '@/components/report/OrdersReportExportModal.vue';
import OrdersReportFiltersModal from '@/components/report/OrdersReportFiltersModal.vue';
import SuitesPanel from '@/components/shared/suites/panels/SuitesPanel.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';
import DatePicker from '@/components/shared/DatePicker.vue';
import RestaurantSelector from '@/components/shared/RestaurantSelector.vue';
import SelectComponent from '@/components/shared/Select.vue';
import { PERMISSION } from '@/permissions';

const namespace = 'auth';

@Component<OrdersReportActions>({
	components: {
		SelectComponent,
		TextButton,
		OrderItemsList,
		OrderItem,
		SuitesPanel,
		DatePicker,
		OrdersTable,
		ChitPrint,
		RestaurantSelector,
		OrdersReportExportModal,
		OrdersReportFiltersModal
	}
})
export default class OrdersReportActions extends Vue {
	@Getter('isK12Location', { namespace }) private isK12Location!: boolean;
	@Getter('hasPermission', { namespace }) private hasPermission!: (permission: PERMISSION) => boolean;
	@Prop({ type: Array, default: () => [] }) private schoolOptions!: { text: string; value: number; }[];
	@Prop({ type: Array, default: () => [] }) private selectedDateRange!: string[];
	@Prop({ type: Array, default: () => [] }) private selectedCreatedAtDateRange!: string[];
	@Prop({ type: String, default: '' }) private selectedDate!: string;
	@Prop({ type: Number, default: 0 }) private selectedSchool!: number;
	@Prop({ type: Boolean, default: false }) private includePrices!: boolean;
	@Prop({ type: Boolean, default: false }) private isFetching!: boolean;
	@Prop({ type: Boolean, default: false }) private isExporting!: boolean;

	private PERMISSION = PERMISSION;
	private showFiltersModal: boolean = false;

	private get activeFiltersCount(): number {
		return [
			this.includePrices,
			this.selectedCreatedAtDateRange.length === 2
		].filter(Boolean).length;
	}

	private get filtersButtonText(): string {
		return this.$t('orders.report.filters_btn_text') + `${this.activeFiltersCount ? ` (${this.activeFiltersCount})` : ''}`;
	}

	/**
	 * Emit to set the applied filters in the parent component.
	 *
	 * @param {{ includePrices: boolean; dateRange: string[] }} filters
	 * @return {void}
	 */
	private handleApplyFilters(filters: { includePrices: boolean; dateRange: string[] }): void {
		const { includePrices, dateRange } = filters;
		this.$emit('update:include-prices', includePrices);
		this.$emit('update:selected-created-at-date-range', dateRange);
		this.showFiltersModal = false;
	}

	/**
	 * Filter date picker's dates to allow only dates within the max range if a first date is selected
	 * * Limiting to 7 days for k12 as they have a high amount of orders
	 * * 45 days for non-k12 locations
	 *
	 * @param {string} candidateDate - date to check
	 * @return {boolean}
	 */
	private maxRange(candidateDate: string): boolean {
		const maxDays = this.isK12Location ? 7 : 45;
		return isDateWithinMaxRange(candidateDate, this.selectedDateRange, maxDays);
	}
}
